export const ACTIONS = {
  VIEW_ANSWER_QUESTION: 12,
  VIEW_ANSWER_DOUBT: 13,
};
